export default "__VITE_ASSET__Dtxmrl6n__"